var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 3.18629 2.68629 0.5 6 0.5H42C45.3137 0.5 48 3.18629 48 6.5V27.5C48 30.8137 45.3137 33.5 42 33.5H6C2.68629 33.5 0 30.8137 0 27.5V6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 1.5H6C3.23858 1.5 1 3.73858 1 6.5V27.5C1 30.2614 3.23858 32.5 6 32.5H42C44.7614 32.5 47 30.2614 47 27.5V6.5C47 3.73858 44.7614 1.5 42 1.5ZM6 0.5C2.68629 0.5 0 3.18629 0 6.5V27.5C0 30.8137 2.68629 33.5 6 33.5H42C45.3137 33.5 48 30.8137 48 27.5V6.5C48 3.18629 45.3137 0.5 42 0.5H6Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownCard);
export default __webpack_public_path__ + "static/media/UnknownCard.573c5aacd238f8e95edd08d5a17910b0.svg";
export { ForwardRef as ReactComponent };